import api from './axiosConfig';

export const verificationService = {
  async verifyIdentity(token: string) {
    try {
      const response = await api.post('/verification/verify-identity', { token });
      return response.data;
    } catch (error) {
      console.error('Failed to verify identity:', error);
      throw error;
    }
  },

  async getBookingPin(bookingId: string) {
    try {
      const response = await api.get(`/verification/booking/${bookingId}/pin`);
      return response.data;
    } catch (error) {
      console.error('Failed to get booking PIN:', error);
      throw error;
    }
  }
}; 